export const cn = {
    title: {
        manageSubscription: '管理订阅',
        pickYourPlan: '选择计划',
        basicUser: '选择适合您的计划',
        proUser: '管理订阅',
        plansAndPricing: '定价方案',
    },
    subtitle: {
        pickYourPlan: '选择适合您的计划',
        basicUser: '解锁专业功能，提升您的生产力',
        proUser: '选择适合您的计划',
        plansAndPricing: '按需选择，找到最适合你的方案',
    },
    mostPopular: '人气首选',
    recommend: '推荐',
    currentPlan: '当前方案',
    active: '已激活',
    canceled: '已取消',
    changePlan: '切换方案',
    cancelPlan: '取消方案',
    resumePlan: '恢复方案',
    month: '月',
    year: '年',
    flashSale: '闪促 50% OFF',
    billingCycle: {
        monthly: '月付',
        yearly: '年付',
        saveAmount: '省 $ {amount}',
    },
    cancelPlanSuccess: '订阅已取消。您的订阅将保持活动状态直到 {date}',
    resumePlanSuccess: '订阅已恢复成功！您的订阅现在已再次激活',
    plans: {
        basic: {
            sectionTitle: '您的基础方案',
            featureTitle: '基础方案功能:',
            name: '基础版',
            pricing: '免费',
            description: '一站式体验 AI 智能体全流程专利检索与撰写服务',
            cta: '立即开始',
            featuresHeader: '专利检索:',
            featuresHeader2: '专利撰写:',
            features: {
                0: '查新检索',
                1: '防侵权检索',
                2: '外观防侵权检索',
                3: 'Hiro Copilot 对话交互',
                4: '发明披露文件生成',
                5: '专利申请文件撰写',
                6: '审查意见答复',
                7: '模板 / 指令 / 格式自定义',
                8: 'Word插件 (即将发布)',
            },
        },
        pro: {
            sectionTitle: '您的方案',
            featureTitle: '专业方案功能',
            name: '专业版',
            subtitle: '月付/年付享优惠',
            description: '为个人研究人员提供部分功能。',
            buttonText: '订阅专业版',
            featuresHeader: '拥有更大容量的专利检索智能体:',
            features: {
                0: '所有功能',
                1: '支持所有格式下载',
                2: '标准邮件支持',
            },
        },
        proSearch: {
            name: '专利检索方向',
            desc: '专业级专利检索与现有技术分析',
            pricing: {
                monthly: '200 美元 / 月',
                yearly: '年付优惠价 2160 美元 / 月',
            },
            buttonText: '订阅专业版',
            featuresHeader: '拥有更大容量的专利检索智能体：',
            features: {
                0: '查新检索（最多 10 个任务）',
                1: '防侵权检索（最多 5 个任务）',
                2: '外观防侵权检索（最多 10 个任务）',
            },
        },
        proDrafting: {
            name: '专利撰写方向',
            desc: '加速专利申请全流程工作流',
            pricing: {
                monthly: '200 美元 / 月',
                yearly: '年付优惠价 2160 美元 / 月',
            },
            buttonText: '订阅专业版',
            featuresHeader: '全球专利申请全流程撰写辅助功能:',
            features: {
                0: '额外 Hiro Copilot 对话次数',
                1: '完整文档导出',
                2: '发明披露文件生成(10篇)',
                3: '专利申请文件撰写(5篇)',
                4: '审查意见答复(5篇)',
                5: '模板 / 指令 / 风格自定义',
                6: 'Word插件 (即将发布)',
            },
        },
        enterprise: {
            name: '企业版',
            description: '为企业提供全维度知识产权保护方案',
            buttonText: '预约演示',
            title: '联系我们',
            featuresHeader: '包含检索专业版全部功能，额外新增：',
            featuresHeader2: '包含撰写专业版全部功能，额外新增：',
            featuresHeader3: '安全与管控能力：',
            features: {
                0: '检索量扩容',
                1: '人机协同校验',
                2: '高级在线编辑器',
                3: '团队工作空间集成',
                4: '专业文档导出',
                5: '更多 Hiro Copilot 对话次数',
                6: 'Word插件 (即将发布)',
                7: 'SSO 单点登录与高级安全配置',
                8: '专属客户成功经理',
            },
        },
        api: {
            name: 'API 版',
            description: '知识产权情报能力无缝集成',
            buttonText: '了解更多',
            title: '定制化报价',
            featuresHeader: '包含专业版,以及:',
            features: {
                0: '可落地的 AI - 数据闭环洞察能力',
                1: '模块化组件与 SDK 快速集成',
                2: '透明用量模式，可预测的弹性扩容',
                3: '企业级基础设施，99.9% 服务等级协议 (SLA)',
                4: '主流技术栈通用适配',
                5: '主动支持与健康监控',
            },
        },
    },
    viewMoreDetails: '查看更多详情',
    error: {
        createPaymentSessionFailed: '创建支付失败,请稍后重试',
    },
};

export const en = {
    title: {
        manageSubscription: 'Manage Subscription',
        pickYourPlan: 'Pick your plan',
        basicUser: 'Choose the Right Plan for You',
        proUser: 'Manage Subscription',
        plansAndPricing: 'Plans & Pricing',
    },
    subtitle: {
        pickYourPlan: 'Choose the plan that works for you',
        basicUser: 'Unlock professional features and boost your productivity.',
        proUser: 'Choose the plan that works for you',
        plansAndPricing: 'Autonomy for all. Choose the best plan for you.',
    },
    mostPopular: 'Most Popular',
    recommend: 'Recommend',
    currentPlan: 'Current Plan',
    active: 'ACTIVE',
    canceled: 'Canceled',
    changePlan: 'Change plan',
    cancelPlan: 'Cancel plan',
    resumePlan: 'Resume plan',
    month: 'month',
    year: 'year',
    flashSale: 'Flash Sale 50% OFF',
    billingCycle: {
        monthly: 'Monthly',
        yearly: 'Yearly',
        saveAmount: 'Save $ {amount}',
    },
    cancelPlanSuccess: 'Subscription canceled successfully.Your subscription will remain active until {date}',
    resumePlanSuccess: 'Subscription resumed successfully! Your subscription is now active again',
    plans: {
        basic: {
            sectionTitle: 'Your Basic Plan',
            featureTitle: 'Basic Plan Features:',
            name: 'Basic',
            pricing: 'Free',
            description: 'Experience AI Agents for end-to end patent search and drafting.',
            cta: 'Get Started',
            featuresHeader: 'Patent Searching:',
            featuresHeader2: 'Patent Drafting:',
            features: {
                0: 'Novelty Search',
                1: 'FTO Search',
                2: 'Design FTO Search',
                3: 'Hiro Copilot messages',
                4: 'Invention Disclosure',
                5: 'Patent Application',
                6: 'Office Action Response',
                7: 'Template/Instruction/Style',
                8: 'Word Plugin (coming soon)',
            },
        },
        pro: {
            sectionTitle: 'Your Plan',
            featureTitle: 'Pro Plan Futures',
            name: 'Pro',
            subtitle: 'Monthly/Yearly with Discount',
            description: 'Partial features for individual researchers.',
            buttonText: 'Upgrade',
            featuresHeader: 'Plan Features:',
            features: {
                0: 'All Features',
                1: 'All formats download supported',
                2: 'Standard email support',
            },
        },
        proSearch: {
            name: 'Patent Searching',
            desc: 'Professional-grade patent search and prior art analysis',
            pricing: {
                monthly: '$200/month',
                yearly: 'Yearly discount price $2160 / month',
            },
            buttonText: 'Subscribe to Pro',
            featuresHeader: 'Patent searching agents with expanded volume:',
            features: {
                0: 'Novelty Search (Max 10 Tasks)',
                1: 'FTO Search (Max 5 Tasks)',
                2: 'Design FTO Search (Max 10 Tasks) ',
            },
        },
        proDrafting: {
            name: 'Patent Drafting',
            desc: 'Accelerated drafting a prosecution workflow',
            pricing: {
                monthly: '$180 / month',
                yearly: 'Yearly discount price $360 / month',
            },
            buttonText: 'Subscribe to Pro',
            featuresHeader: 'Multiple drafting features to assist with global patent applications:',
            features: {
                0: 'Additional Hiro messages',
                1: 'Full document exports',
                2: 'Invention Disclosure (10 Doc)',
                3: 'Patent Application (5 Doc)',
                4: 'Office Action Response (5 Doc)',
                5: 'Template/Instruction/Style',
                6: 'Word Plugin (coming soon)',
            },
        },
        enterprise: {
            name: 'Enterprise',
            description: 'Comprehensive IP protection for organizations',
            buttonText: 'Book a Demo',
            title: 'Contact us',
            featuresHeader: 'Everything in Searching pro, plus:',
            featuresHeader2: 'Everything in Drafting pro, plus:',
            featuresHeader3: 'Security & Control:',
            features: {
                0: 'Expanded search volume',
                1: 'Human-in-the-loop',
                2: 'Advanced inline editor',
                3: 'Workspace integration',
                4: 'Professional document export',
                5: 'Even more Hiro Copilot messages',
                6: 'Word Plugin (coming soon)',
                7: 'SSO & advanced security',
                8: 'Dedicated customer success manager',
            },
        },
        api: {
            name: 'API',
            description: 'Seamless IP intelligence integration',
            buttonText: 'Learn More',
            title: 'Custom',
            featuresHeader: 'Includes Pro, plus:',
            features: {
                0: 'Unified AI-data loop for actionable insights',
                1: 'Instant integration via modular widgets and SDKs',
                2: 'Predictable scaling with transparent usage models',
                3: 'Enterprise-grade infrastructure with 99.9% SLA',
                4: 'Universal connectivity across leading tech stacks',
                5: 'Proactive support and health monitoring',
            },
        },
    },
    viewMoreDetails: 'View more details',
    error: {
        createPaymentSessionFailed: 'Failed to create payment, please try again later',
    },
};

export const jp = {
    title: {
        manageSubscription: 'サブスクリプション管理',
        pickYourPlan: 'プランを選択',
        basicUser: 'あなたに合ったプランを選択',
        proUser: 'サブスクリプション管理',
        plansAndPricing: 'プランと料金',
    },
    subtitle: {
        pickYourPlan: 'あなたに合ったプランをお選びください',
        basicUser: 'プロフェッショナル機能をアンロックし、生産性を向上',
        proUser: 'あなたに合ったプランをお選びください',
        plansAndPricing: '必要に応じて選ぶ，最適なプランを見つけよう',
    },
    mostPopular: '最も選ばれている',
    recommend: 'おすすめ',
    currentPlan: '現在のプラン',
    active: '有効',
    canceled: 'キャンセル済み',
    changePlan: 'プラン変更',
    cancelPlan: 'プランキャンセル',
    resumePlan: 'プラン再開',
    month: '月',
    year: '年',
    flashSale: '閃促 50% OFF',
    billingCycle: {
        monthly: '月払い',
        yearly: '年払い',
        saveAmount: '$ {amount} お得',
    },
    cancelPlanSuccess: 'サブスクリプションが正常にキャンセルされました。あなたのサブスクリプションは {date} までアクティブのままです',
    resumePlanSuccess: 'サブスクリプションが正常に再開されました！あなたのサブスクリプションは今すぐアクティブになりました',
    plans: {
        basic: {
            sectionTitle: 'ベーシックプラン',
            featureTitle: 'ベーシックプラン機能:',
            name: 'ベーシック',
            pricing: '無料',
            description: 'AI エージェントによる一貫した特許検索・明細書作成をフル体験',
            cta: '今すぐ始める',
            featuresHeader: '特許検索:',
            featuresHeader2: '特許明細書作成:',
            features: {
                0: '新規性検索',
                1: 'FTO 調査',
                2: '意匠 FTO 調査',
                3: 'Hiro コパイロットとのチャット機能',
                4: '発明開示書作成',
                5: '特許出願書類作成',
                6: '拒絶理由通知応答',
                7: 'テンプレート / 指示 / スタイルのカスタマイズ',
                8: 'Wordプラグイン（近日公開予定）',
            },
        },
        pro: {
            sectionTitle: 'プロプラン',
            featureTitle: 'プロプラン機能',
            name: 'プロ',
            subtitle: '月払い/年払い割引あり',
            description: '個人研究者向けの部分機能。',
            buttonText: 'アップグレード',
            featuresHeader: 'プラン機能:',
            features: {
                0: 'すべての機能',
                1: 'すべての形式のダウンロードに対応',
                2: '標準メールサポート',
            },
        },
        proSearch: {
            name: '特許検索方向',
            desc: 'プロフェッショナルレベルの特許検索・先行技術分析',
            pricing: {
                monthly: '$200 / 月',
                yearly: '年払い割引価格 $2160 / 月',
            },
            buttonText: 'プロプランに申し込む',
            featuresHeader: '検索ボリューム拡張の特許検索エージェント：',
            features: {
                0: '新規性検索（最大 10 タスク）',
                1: 'FTO 調査（最大 5 タスク）',
                2: '意匠 FTO 調査（最大 10 タスク）',
            },
        },
        proDrafting: {
            name: '特許明細書作成方向',
            desc: '特許出願業務フローを高速化',
            pricing: {
                monthly: '$200 / 月',
                yearly: '年払い割引価格 $2160 / 月',
            },
            buttonText: 'プロプランに申し込む',
            featuresHeader: '世界各国の特許出願に対応した明細書作成支援機能：',
            features: {
                0: 'Hiro コパイロット追加チャット回数',
                1: 'フルドキュメントエクスポート',
                2: '発明開示書作成 (10件)',
                3: '特許出願書類作成 (5件)',
                4: '拒絶理由通知応答 (5件)',
                5: 'テンプレート / 指示 / スタイルのカスタマイズ',
                6: 'Wordプラグイン（近日公開予定）',
            },
        },
        enterprise: {
            name: 'エンタープライズ',
            description: '企業向け包括的な知的財産保護ソリューション',
            buttonText: 'デモを予約する',
            title: 'お問い合わせ',
            featuresHeader: '検索プロプランの全機能に加えて：',
            featuresHeader2: '明細書作成プロプランの全機能に加えて：',
            featuresHeader3: 'セキュリティ・管理機能：',
            features: {
                0: '検索ボリューム拡張',
                1: '人間介入型の検証フロー',
                2: '高度インラインエディタ',
                3: 'チームワークスペース連携',
                4: 'プロフェッショナルドキュメントエクスポート',
                5: 'Hiro コパイロット追加チャット回数',
                6: 'Wordプラグイン（近日公開予定）',
                7: 'SSO シングルサインオン & 高度セキュリティ',
                8: '専属カスタマーサクセスマネージャー',
            },
        },
        api: {
            name: 'API 版',
            description: '知的財産インテリジェンスのシームレスなシステム連携',
            buttonText: '詳細を見る',
            title: 'カスタム見積もり',
            featuresHeader: 'プロ版に加えて:',
            features: {
                0: '実用的な AI - データループによるインサイト提供',
                1: 'モジュラーウィジェット・SDK による即時システム連携',
                2: '透明な利用モデルで予測可能なスケーリング',
                3: '企業向けインフラ、99.9% の SLA 保証',
                4: '主要技術スタックへの汎用的な連携性',
                5: '積極的なサポートと稼働状況監視',
            },
        },
    },
    viewMoreDetails: '詳細を見る',
    error: {
        createPaymentSessionFailed: '支払いの作成に失敗しました,後でもう一度お試しください',
    },
};

export const tw = {
    title: {
        manageSubscription: '管理訂閱',
        pickYourPlan: '選擇方案',
        basicUser: '選擇適合您的方案',
        proUser: '管理訂閱',
        plansAndPricing: '定價方案',
    },
    subtitle: {
        pickYourPlan: '選擇適合您的方案',
        basicUser: '解鎖專業功能，提升您的生產力',
        proUser: '選擇適合您的方案',
        plansAndPricing: '按需選擇，找到最適合你的方案',
    },
    mostPopular: '人氣首選',
    recommend: '推薦',
    currentPlan: '目前方案',
    active: '已啟用',
    canceled: '已取消',
    changePlan: '切換方案',
    cancelPlan: '取消方案',
    resumePlan: '恢復方案',
    month: '月',
    year: '年',
    flashSale: '閃促 50% OFF',
    billingCycle: {
        monthly: '月付',
        yearly: '年付',
        saveAmount: '省 $ {amount}',
    },
    cancelPlanSuccess: '訂閱已取消。您的訂閱將保持活動狀態直到 {date}',
    resumePlanSuccess: '訂閱已恢復成功！您的訂閱現在已再次激活',
    plans: {
        basic: {
            sectionTitle: '您的基礎方案',
            featureTitle: '基礎方案功能:',
            name: '基礎版',
            pricing: '免費',
            description: '一站式體驗 AI 智慧體全流程專利檢索與撰寫服務',
            cta: '立即開始',
            featuresHeader: '專利檢索:',
            featuresHeader2: '專利撰寫:',
            features: {
                0: '查新檢索',
                1: '防侵權檢索',
                2: '外觀防侵權檢索',
                3: 'Hiro Copilot 對話互動',
                4: '發明揭露文件生成',
                5: '專利申請文件撰寫',
                6: '核駁意見答覆',
                7: '範本 / 指令 / 格式自定義',
                8: 'Word插件 (即將發佈)',
            },
        },
        pro: {
            sectionTitle: '您的方案',
            featureTitle: '專業方案功能',
            name: '專業版',
            subtitle: '月付/年付享優惠',
            description: '為個人研究人員提供部分功能。',
            buttonText: '升級',
            featuresHeader: '方案功能:',
            features: {
                0: '所有功能',
                1: '支援所有格式下載',
                2: '標準郵件支援',
            },
        },
        proSearch: {
            name: '專利檢索方向',
            desc: '專業級專利檢索與先前技術分析',
            pricing: {
                monthly: '200 美元 / 月',
                yearly: '年繳優惠價 2160 美元 / 月',
            },
            buttonText: '訂閱專業版',
            featuresHeader: '擁有更大容量的專利檢索智慧體：',
            features: {
                0: '查新檢索（最多 10 個任務）',
                1: '防侵權檢索（最多 5 個任務）',
                2: '外觀防侵權檢索（最多 10 個任務）',
            },
        },
        proDrafting: {
            name: '專利撰寫方向',
            desc: '加速專利申請全流程工作流',
            pricing: {
                monthly: '200 美元 / 月',
                yearly: '年繳優惠價 2160 美元 / 月',
            },
            buttonText: '訂閱專業版',
            featuresHeader: '全球專利申請全流程撰寫輔助功能：',
            features: {
                0: '額外 Hiro Copilot 對話次數',
                1: '完整文件匯出',
                2: '發明揭露文件生成 (10篇)',
                3: '專利申請文件撰寫 (5篇)',
                4: '核駁意見答覆 (5篇)',
                5: '範本 / 指令 / 格式自定義',
                6: 'Word插件 (即將發佈)',
            },
        },
        enterprise: {
            name: '企業版',
            description: '為企業提供全維度智慧財產保護方案',
            buttonText: '預約演示',
            title: '聯絡我們',
            featuresHeader: '包含檢索專業版全部功能，額外新增：',
            featuresHeader2: '包含撰寫專業版全部功能，額外新增：',
            featuresHeader3: '安全與管控能力：',
            features: {
                0: '檢索量擴容',
                1: '人機協同校驗',
                2: '高級線上編輯器',
                3: '團隊工作空間整合',
                4: '專業文件匯出',
                5: '更多 Hiro Copilot 對話次數',
                6: 'Word插件 (即將發佈)',
                7: 'SSO 單點登入與高級安全配置',
                8: '專屬客戶成功經理',
            },
        },
        api: {
            name: 'API 版',
            description: '智慧財產情報能力無縫整合',
            buttonText: '瞭解更多',
            title: '客製化報價',
            featuresHeader: '包含專業版,以及:',
            features: {
                0: '可落地的 AI - 數據閉環洞察能力',
                1: '模組化組件與 SDK 快速整合',
                2: '透明用量模式，可預測的彈性擴容',
                3: '企業級基礎設施，99.9% 服務等級協議 (SLA)',
                4: '主流技術棧通用適配',
                5: '主動支援與健康監控',
            },
        },
    },
    viewMoreDetails: '查看更多詳情',
    error: {
        createPaymentSessionFailed: '建立付款失敗，請稍後再試',
    },
};
